import type { RotasDoModulo } from '@/app/rotas';

import { DashboardPage } from './DashboardPage';

/** O painel e o item "/" do menu, e por isso a rota inicial da moldura. */
export const rotas: RotasDoModulo = {
  menu: { '/': DashboardPage },
};
